import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#services', label: 'Services' },
    { href: '#about', label: 'About' },
    { href: '#gallery', label: 'Gallery' },
    { href: '#contact', label: 'Contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-[#1B3A3A] shadow-lg py-2'
          : 'bg-transparent py-3'
      }`}
    >
      <div className="container mx-auto px-4 md:px-6">
        <div
          className={`flex items-center justify-between ${
            isScrolled
              ? ''
              : 'bg-[#1B3A3A]/95 backdrop-blur-sm rounded-2xl px-6 py-2'
          }`}
        >
          {/* Logo - MUCH Larger and More Prominent */}
          <a href="#" className="flex items-center">
            <img
              src={companyInfo.logo}
              alt={companyInfo.name}
              className={`w-auto transition-all duration-300 ${
                isScrolled ? 'h-20 md:h-24' : 'h-24 md:h-32'
              }`}
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-white text-lg font-medium hover:text-[#C5D89A] transition-colors"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center gap-6">
            <a
              href={`tel:${companyInfo.phone}`}
              className="flex items-center gap-2 text-white font-bold text-xl hover:text-[#C5D89A] transition-colors"
            >
              <Phone size={22} />
              {companyInfo.phone}
            </a>
            <a href="#contact" className="btn-accent text-lg px-8 py-4 font-bold">
              Get a Quote
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={36} /> : <Menu size={36} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 bg-[#1B3A3A] rounded-2xl p-6 animate-scale-in">
            {/* Mobile Logo - Large */}
            <div className="flex justify-center mb-6 pb-4 border-b border-white/10">
              <img
                src={companyInfo.logo}
                alt={companyInfo.name}
                className="h-28 w-auto"
              />
            </div>
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-white text-xl font-medium py-3 border-b border-white/10 hover:text-[#C5D89A] transition-colors"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {link.label}
                </a>
              ))}
              <a
                href={`tel:${companyInfo.phone}`}
                className="flex items-center justify-center gap-2 text-white font-bold text-xl py-3 hover:text-[#C5D89A] transition-colors"
              >
                <Phone size={22} />
                {companyInfo.phone}
              </a>
              <a
                href="#contact"
                className="btn-accent text-center mt-2 py-4 text-xl font-bold"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Get a Quote
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
